import React from "react";
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { Field } from "./Field";

const useStyles = makeStyles(theme => ({
  formItem: {
    marginBottom: theme.spacing(3)
  },
  inline: {
    display: "flex",
    alignItems: "center",

    "& $label": {
      marginBottom: 0
    }
  },
  label: {
    display: "inline-block",
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  labelBold: {
    fontWeight: "bold"
  },
  requiredBefore: {
    "&:before": {
      content: "'*'",
      color: theme.palette.secondary.main,
      marginRight: 5,
      marginLeft: -5
    }
  },
  requiredAfter: {
    "&:after": {
      content: "'*'",
      color: theme.palette.secondary.main,
      marginLeft: 5
    }
  },
  content: {
    flex: 1
  },
  errMsg: {
    marginTop: theme.spacing(1)
  }
}));

const FormItem = ({
  label,
  labelBold,
  labelWidth,
  required,
  requireMarkType = "after",
  colon = true,
  disabled,
  noStyle,
  row,
  className,
  style,
  children,
  name,
  innerRef,
  validate,
  rules
}) => {
  const classes = useStyles();

  const content = name ? (
    <Field
      name={name}
      disabled={disabled}
      innerRef={innerRef}
      validate={validate}
      rules={rules}
    >
      {children}
    </Field>
  ) : (
    children
  );

  if (noStyle) {
    return content;
  }

  return (
    <div
      className={clsx(classes.formItem, !row && classes.inline, className)}
      style={style}
    >
      {label && (
        <div
          className={clsx(
            classes.label,
            required && classes.required,
            labelBold && classes.labelBold,
            required &&
              (requireMarkType === "before"
                ? classes.requiredBefore
                : classes.requiredAfter)
          )}
          style={{ width: labelWidth }}
        >
          {label}
          {colon ? ":" : ""}
        </div>
      )}
      <div className={classes.content}>{content}</div>
    </div>
  );
};

export default FormItem;
